<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
@import './assets/css/resources'
@import url('https://fonts.googleapis.com/css?family=Poppins:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i|Raleway:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i');

html
  scroll-behavior smooth

html, body
  height 100%
  min-height 100%

body
  margin 0
  padding 0

#app
  min-height 100%
  height 100%
  font-family 'Poppins', sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #222222

.section-title
  color black
  font-weight 400
  position relative
  text-transform uppercase
  margin-top 150px
  &.light
    color white

  strong
    font-weight 700

  &:before
    content ''
    position absolute
    bottom 0
    width 60px
    height 2px
    background-color $revisacar-red

@media (max-width: 1366px)
  .section-title
    margin-top 50px
</style>



// WEBPACK FOOTER //
// src/App.vue